// extracted by mini-css-extract-plugin
export default {"-large":"on-my-design-section-module__-large--Tz4nb","onMyDesignHeading":"on-my-design-section-module__onMyDesignHeading--pzeSo"};